import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";

export class MemberInfo
{
  static readonly method = new AttributeValue( ElementAttribute.dataType, "method" );
  static readonly accessor = new AttributeValue( ElementAttribute.dataType, "accessor" );
  static readonly property = new AttributeValue( ElementAttribute.dataType, "property" );
  static readonly constructorAV = new AttributeValue( ElementAttribute.dataType, "constructor" );
  static readonly constant = new AttributeValue( ElementAttribute.dataType, "constant" );
  static readonly operator = new AttributeValue( ElementAttribute.dataType, "operator" );
  static readonly signal = new AttributeValue( ElementAttribute.dataType, "signal" );
  static readonly enum = new AttributeValue( ElementAttribute.dataType, "enum" );
  
   
  static readonly type = new ElementType( "member-info" );
  static readonly memberType = new ElementAttribute( "type" );
  static readonly memberName = new ElementType( "member-name" );
  static readonly parameters = new ElementType( "member-parameters" );
  static readonly parameter = new ElementType( "member-parameter" );
  static readonly parameterType = new ElementType( "member-parameter-type" );
  static readonly parameterName = new ElementType( "member-parameter-name" );
  static readonly parameterValue = new ElementType( "member-parameter-value" );

  static readonly memberAttributes = new ElementType( "member-attributes" );
  static readonly memberAttribute = new ElementType( "member-attribute" );
  static readonly memberAttributeValue = new ElementAttribute( "value" );
  static readonly memberAttributeParameters= new ElementAttribute( "parameters" );

  static readonly exportedMember = new ElementAttribute( "exported-member" );
  static readonly exportedMembersOnly = new ElementAttribute( "exported-members-only" );
  static readonly dataType = new ElementType( "member-data-type" );
  static readonly title = new ElementType( "member-title" );
  static readonly description = new ElementType( "member-description" );
  static readonly modifiers = new ElementType( "member-modifiers" );
  static readonly actionMember = new ElementAttribute( "action-member" );

  static readonly memberHeader = new ElementType( "member-header" );


}